import PropTypes from 'prop-types';

export default {
  autoComplete: PropTypes.string,
  autoFocus: PropTypes.bool,
  label: PropTypes.string,
  maxLength: PropTypes.number,
  name: PropTypes.string,
  required: PropTypes.bool,
  type: PropTypes.string,
  validate: PropTypes.arrayOf(PropTypes.func),
  xssCheckExempt: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  placeholder: PropTypes.string,
  containerId: PropTypes.string,
  link: PropTypes.string,
  toolTip: PropTypes.string,
  fixedLength: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
  inputMode: PropTypes.string,
  validationCleaner: PropTypes.func,
  width: PropTypes.number,
  helperText: PropTypes.string,
  autocomplete: PropTypes.string,
  pattern: PropTypes.string,
};
